/**
 * 조직도의 선 — 본사 트리({@code OrgTreeChart})와 현장 판({@code OrgChartBoard})이 같은 모양으로 긋는다
 * (사용자 지시 2026-10-01 「현장의 디자인도 이거로 통일」).
 */

/** 칸 그림자. 두 조직도가 같은 값을 써야 한 화면처럼 읽힌다. */
export const ORG_CARD_SHADOW = '0 1px 2px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.06)';

/**
 * 부모 아래 → 버스(가로줄) → 자식 위. 모서리는 살짝 둥글린다 — 직각 그대로면 선이 표 괘선처럼 읽힌다.
 *
 * <p>버스는 부르는 쪽이 정한다. <b>자식 바로 위의 빈 띠</b>에 두어야 어느 줄에서 와도 칸을 뚫지 않는다.
 */
export function elbowPath(px: number, py: number, cx: number, cy: number, busY: number): string {
  if (Math.abs(px - cx) < 1) return `M ${px} ${py} V ${cy}`;
  const r = Math.max(0, Math.min(8, Math.abs(cx - px) / 2, busY - py, cy - busY));
  const dir = cx > px ? 1 : -1;
  return [
    `M ${px} ${py}`,
    `V ${busY - r}`,
    `Q ${px} ${busY} ${px + dir * r} ${busY}`,
    `H ${cx - dir * r}`,
    `Q ${cx} ${busY} ${cx} ${busY + r}`,
    `V ${cy}`,
  ].join(' ');
}
